import { isEmpty, isNil, trim } from "lodash-es";
import { UUID_V4_PATTERN } from "../utils/uuid";
import { placeholderPattern } from "../utils/placeholderUtil";
import { OLD_FIELD_ID_PATTERN } from "../utils/fieldUtil";
import { bounded } from "../utils/regexUtil";
import FieldValueReference from "../fields/FieldValueReference";
import { type Delimiter, type StringTemplate, type StringTemplateTypes } from "../utils/stringTemplateUtil";
import type { VariableConfig } from "../fields/types";
import VariableValueReference from "../variables/VariableValueReference";
import MetaVariableReference from "../metaVariables/MetaVariableReference";
import { isMetaVariable } from "../metaVariables/metaVariable";

export const parseToRecipients = (
  value?: string | string[],
  variables: VariableConfig[] = [],
  delimiter: Delimiter = "${",
): StringTemplate => {
  if (isNil(value)) {
    return [];
  }

  const values = Array.isArray(value) ? value : value.split(",");

  return values
    .map(trim)
    .filter((v) => !isEmpty(v))
    .map((v) => determineType(v, delimiter, variables));
};

const determineType = (value: string, delimiter: Delimiter, variables: VariableConfig[]): StringTemplateTypes => {
  if (variables.some((variable) => variable.uid.equals(value))) {
    return {
      type: "variable",
      value: VariableValueReference.from(value),
    };
  }

  if (UUID_V4_PATTERN.test(value) || OLD_FIELD_ID_PATTERN.test(value)) {
    return {
      type: "field",
      value: FieldValueReference.from(value),
    };
  }

  if (bounded(placeholderPattern(delimiter)).test(value)) {
    const withoutDelimiter = value.slice(delimiter.length, -1);
    if (isMetaVariable(withoutDelimiter)) {
      return {
        type: "metaVariable",
        value: MetaVariableReference.from(withoutDelimiter),
      };
    }
  }

  return {
    type: "literal",
    value,
  };
};
